import Device from 'src/devices/device';

import PolyfillModule from 'bitmovin-player/modules/bitmovinplayer-polyfill';
import EngineBitmovinModule from 'bitmovin-player/modules/bitmovinplayer-engine-bitmovin';
import EngineNative from 'bitmovin-player/modules/bitmovinplayer-engine-native';
import AbrModule from 'bitmovin-player/modules/bitmovinplayer-abr';
import DrmModule from 'bitmovin-player/modules/bitmovinplayer-drm';
import ContainerMp4Module from 'bitmovin-player/modules/bitmovinplayer-container-mp4';
import MseRendererModule from 'bitmovin-player/modules/bitmovinplayer-mserenderer';
import DashModule from 'bitmovin-player/modules/bitmovinplayer-dash';
import XmlModule from 'bitmovin-player/modules/bitmovinplayer-xml';
import TizenModule from 'bitmovin-player/modules/bitmovinplayer-tizen';
import WebosModule from 'bitmovin-player/modules/bitmovinplayer-webos';
import PlayStation4Module from 'bitmovin-player/modules/bitmovinplayer-playstation4';
import SmoothModule from 'bitmovin-player/modules/bitmovinplayer-smooth';
import SubtitlesModule from 'bitmovin-player/modules/bitmovinplayer-subtitles';
import SubtitlesWebVTTModule from 'bitmovin-player/modules/bitmovinplayer-subtitles-vtt';
import AdsModuleCore from 'bitmovin-player/modules/bitmovinplayer-advertising-core';
import AdsModuleBM from 'bitmovin-player/modules/bitmovinplayer-advertising-bitmovin';
import AnalyticsModule from 'bitmovin-player/modules/bitmovinplayer-analytics';

import AAF from 'src/AAF/AAF';

export const addModules = (Player) => {
    Player.addModule(PolyfillModule);
    Player.addModule(EngineBitmovinModule);
    Player.addModule(EngineNative);
    Player.addModule(AbrModule);
    Player.addModule(DrmModule);
    Player.addModule(ContainerMp4Module);
    Player.addModule(MseRendererModule);
    Player.addModule(XmlModule);
    Player.addModule(DashModule);
    Player.addModule(SmoothModule);
    Player.addModule(SubtitlesModule);
    Player.addModule(SubtitlesWebVTTModule);
    Player.addModule(AdsModuleCore);
    Player.addModule(AdsModuleBM);
    Player.addModule(AnalyticsModule);

    const devicePlatform = Device.getDevice().getPlatform();
    if (devicePlatform === 'tizen') {
        if(AAF.AdsUtils.loadBitmovinTizenModule()) {
            Player.addModule(TizenModule);
        }
    }
    if (devicePlatform === 'web0s') Player.addModule(WebosModule);
    if (devicePlatform === 'ps4') Player.addModule(PlayStation4Module);
};



// WEBPACK FOOTER //
// ./src/devices/all/bitmovin/utils/addModules.js